import React, { useEffect, useState } from "react";
import FilesStatus from "./filesStatus";
import TableRegCmp from "./TableRegCmp";
import { useQuery, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { ACTIVE_DIV, WORK_FLOW_TYPE } from "../../config/cacheKey";
import { GetCartablesResponse } from "../../models/cartable.model";
import { GetCartables } from "../../services/cartable.service";
import { setstateCartable } from "../../redux/activeState/activeStateAction";
import { useHistory } from "react-router-dom";
export default function LoanRegPage() {
  //test
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  let history = useHistory<{ refetchStatus: boolean }>();
  const [activeState, setActiveState] = useState<any>(
    queryClient.getQueryData(ACTIVE_DIV)
  );
  useEffect(() => {
    if (
      history.location.state != undefined &&
      history.location.state.refetchStatus == true
    ) {
      queryClient.setQueryData(ACTIVE_DIV, 0);
      setActiveState(0);
      refetch();
      history.replace({ state: { refetchStatus: false } });
    }
  }, [history.location.state]);
  useEffect(() => {
    setActiveState(queryClient.getQueryData(ACTIVE_DIV));
  });
  let { data: cartableData, isLoading, refetch } = useQuery<
    GetCartablesResponse[]
  >(
    "GetCartablesReg",
    (): Promise<GetCartablesResponse[]> => {
      //todo
      return GetCartables({
        workflowType: "CustomerRegistration",
      });
    },
    { staleTime: 0, cacheTime: 0 }
  );
  useEffect(() => {
    localStorage.setItem(
      "activeCancleButton",
      JSON.stringify({ activeCancleButton: false })
    );
  }, []);

  if (isLoading) {
    return <></>;
  } else {
    if (cartableData != null) {
      if (cartableData.length > 0) {
        // cartableData[0].status = "success";
        // dispatch(setstateCartable({ stateCartable: cartableData[0].state }));
        cartableData[activeState ? activeState : 0].status = "success";
        dispatch(
          setstateCartable({
            stateCartable: cartableData[activeState ? activeState : 0].state,
          })
        );

        return (
          <div>
            {/* <ToolsCmp />
            <br /> */}
            <FilesStatus
              workFlowType="CustomerRegistration"
              cartableData={cartableData}
            />
            <TableRegCmp />
          </div>
        );
      }
      return (
        <div>
          <img
            className="classCenter"
            style={{ width: "30%", margin: "auto", marginTop: "5vh" }}
            src="images/empthuCartable.png"
          />
        </div>
      );
    }
  }
  //test
}
